import { supabase } from "../supabaseClient";

// Session única por visita
const SESSION_ID = Math.random().toString(36).substring(2, 10);

type DemoEvent =
    | "demo_opened"
    | "menu_viewed"
    | "modal_opened"
    | "modal_closed"
    | "whatsapp_clicked";

export async function trackDemoEvent(
    event: DemoEvent,
    slug: string,
    extra?: { product_id?: string; metadata?: Record<string, unknown> }
) {
    // Solo trackear si hay params de demo en la URL
    const params = new URLSearchParams(window.location.search);
    if (!params.get("product") && !params.get("price")) return;

    await supabase.from("demo_events").insert({
        session_id: SESSION_ID,
        event,
        restaurant_slug: slug,
        product_id: extra?.product_id ?? null,
        metadata: extra?.metadata ?? null,
    });
}